import { NgModule } from '@angular/core';
import { SharedModule } from '../../../core/modules/shared.module';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../../../_guards/auth.guard';
import { RoleGuard } from '../../../_guards/role.guard';
import { AddtosubkeywordComponent } from './addtosubkeyword.component';


const routes: Routes = [
    {
        path: 'addtosubkeyword',
        component: AddtosubkeywordComponent,
        data: {
            permission: {
                only: ['role1', 'role2']
            }
        },
        canActivate: [AuthGuard, RoleGuard]
    }
];

@NgModule({
    imports: [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    declarations: [
        AddtosubkeywordComponent
    ],
    entryComponents: [],
    providers: [
        AuthGuard, RoleGuard
    ]
})
export class AddtosubkeywordModule { }



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/main/content/addtosubkeyword/addtosubkeyword.module.ts